<!--
 * @Author: wjw
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-06-23 09:36:03
 * @LastEditors: wjw
 * @LastEditTime: 2019-12-16 09:23:36
 -->
<template>
  <div class="education-page">
    <div class="video-wrapper">
      <div class="video">
        <video
          :src="videoSrc"
          preload="auto"
          controls
          :poster="lessonInfo.image"
          style="object-fit:fill"
          ref="myVideo"
          @play="videoPlay"
          @ended="playend"
        ></video>
        <div class="video-title">
          <div>{{lessonInfo.title}}</div>
          <div class="container-up">课程安排：{{lessonInfo.lesson_count}}课时</div>
        </div>
      </div>
      <div class="title-wrapper">
        <header>目录</header>
        <ul>
          <li
            v-for="(item, index) in chaptersList"
            :key="item.id"
            @click="handlePlay(item.url, index)"
            :class="{playing:menuIndex === index}"
          >
            <div>{{item.sub_id}}&nbsp;{{item.title}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="lesson-wrapper">
      <div class="an-title">
        <p class="title" :class="{ active:aim }" @mouseenter="changeAn(1)" @click="changeAn(1)">课程简介</p>
        <p class="division-line">|</p>
        <p
          class="title"
          :class="{ active:!aim }"
          @mouseenter="changeAn(0)"
          @click="changeAn(0)"
        >课程目录</p>
      </div>
      <ul class="an-list" v-show="!aim" ref="ul" :style="{height:`${wrapperH + 18}px`}">
        <li
          class="list"
          v-for="(item, index) in chaptersList"
          :key="item.id"
          @click="handlePlay(item.url, index)"
        >
          <div
            class="video-icon"
            :class="{playing:item.playStatus == 1, played:item.playStatus == 2}"
          ></div>
          <div
            class="word"
            :class="{playing:item.playStatus == 1, played:item.playStatus == 2}"
          >{{item.sub_id}}&emsp;·&emsp;{{item.title}}</div>
          <span
            class="time"
            :class="{playing:item.playStatus == 1, played:item.playStatus == 2}"
          >{{item.film_length}}</span>
        </li>
      </ul>
      <div
        class="lesson-intro"
        v-show="aim"
        v-html="lessonInfo.intro_content"
        :style="{height:`${wrapperH}px`}"
      ></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Api from "../../api/networkCourse";
import Filter from "../../util/filter";
export default {
  props: ["menu", "articletitle", "currentPage"],
  data() {
    return {
      lessonInfo: [], // 课程信息
      chaptersList: [], // 章节列表 // playStatus: 1 // 0 未播放 1 正在播放 2播放完成
      count: null, // 总章节数
      videoSrc: "",
      aim: 0,
      menuIndex: 0,
      // 当前正在播放的list索引
      playingIndex: 0
    };
  },
  created() {
    this.showNetworkCourse(this.articletitle, this.currentPage);
  },
  mounted() {},
  methods: {
    // 加载网络课程
    showNetworkCourse(lesson_id, start_page) {
      Api.getChaptersSectionsInfo(lesson_id, 1)
        .then(res => {
          this.lessonInfo = res.data.lessonInfo;
          this.chaptersList = res.data.chaptersList;
          // 默认显示第一个章节视频
          this.videoSrc = this.chaptersList[0].url;
          for (let i = 0; i < this.chaptersList.length; i++) {
            this.chaptersList[i].film_length = Filter.filmFilter(
              this.chaptersList[i].film_length
            );
            Vue.set(this.chaptersList[i], "playStatus", 0); // 添加 playStatus 属性
          }
        })
        .catch(err => console.log(err));
    },
    // 切换显示列表
    changeAn(i) {
      this.aim = i;
    },
    videoPlay() {
      this.chaptersList[this.playingIndex].playStatus = 1;
    },
    // 点击 li 标签
    handlePlay(url, index) {
      this.videoSrc = url;
      this.menuIndex = index;
      this.$refs.myVideo.play();
      this.$refs.myVideo.setAttribute("autoplay", "autoplay");
      if (this.chaptersList[this.playingIndex].playStatus == 1) {
        this.chaptersList[this.playingIndex].playStatus = 0;
        this.playingIndex = index;
        this.chaptersList[this.playingIndex].playStatus = 1;
      } else {
        this.playingIndex = index;
        this.chaptersList[this.playingIndex].playStatus = 1;
      }
    },
    // 播放完成
    playend() {
      this.chaptersList[this.playingIndex].playStatus = 2;
    }
  },
  watch: {
    $route(to, from) {
      to.params.currentPage &&
      to.params.articletitle != from.params.articletitle
        ? this.showNetworkCourse(to.params.articletitle, to.params.currentPage)
        : "";
    }
  },
  computed: {
    wrapperH: function() {
      // 动态设置 详情高度
      let a = this.chaptersList.length * 68 - 17;
      return a < 250 ? 250 : a;
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("minireset.css");
%mgto {
  margin: 0 auto;
}
%ulst {
  margin: 0;
  padding: 0;
  list-style: none;
}

@mixin displayflex($row, $column, $direction, $wrap) {
  display: flex;
  @if $direction == column {
    flex-direction: column;
  } @else {
    flex-direction: row;
  }
  @if $wrap == wrap {
    flex-wrap: wrap;
  } @else {
    flex-wrap: nowrap;
  }
  justify-content: $row;
  align-items: $column;
}
.box-border {
  box-sizing: border-box;
}
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}
.education-page {
  @extend %mgto;
  width: 1200px;
  margin-bottom: 40px;
  @extend .box-border;
  .video-wrapper {
    width: 100%;
    height: 590px;
    display: flex;
    overflow: hidden;
    .video {
      width: 860px;
      @include displayflex(flex-start, flex-start, column, nowrap);
      & > video {
        width: 100%;
        height: 486px;
      }
      & > .video-title {
        width: 100%;
        flex: 1;
        padding: 20px 30px;
        box-sizing: border-box;
        background-color: #1f1f1f;
        & > :first-child {
          @include font-style(PingFangSC, 26px, rgba(255, 255, 255, 1), 500);
          max-width: 100%;
          line-height: 37px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        & > :last-child {
          margin-top: 4px;
          @include font-style(PingFangSC, 16px, rgba(255, 255, 255, 0.7), 400);
          max-width: 100%;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .title-wrapper {
      box-sizing: border-box;
      flex: 1;
      height: 100%;
      background-color: #292929;
      & > header {
        @include font-style(PingFangSC, 22px, rgba(255, 255, 255, 1), 500);
        width: 100%;
        height: 70px;
        line-height: 70px;
        box-sizing: border-box;
        padding-left: 20px;
        background-color: #393939;
      }
      & > ul {
        overflow-y: auto;
        width: 100%;
        height: 100%;
        min-height: calc(100% - 70px);
        & > li {
          width: 100%;
          height: 65px;
          padding: 0 20px;
          border-bottom: 1px solid rgba(219, 219, 219, 0.06);
          @include displayflex(flex-start, center, row, nowrap);
          cursor: pointer;
          & > div {
            max-height: 44px;
            line-height: 22px;
            box-sizing: border-box;
            @include font-style(
              PingFangSC,
              16px,
              rgba(255, 255, 255, 0.6),
              500
            );
            overflow: hidden;
            text-overflow: ellipsis; /*文本溢出时显示省略标记*/
            display: -webkit-box; /*设置弹性盒模型*/
            -webkit-line-clamp: 2; /*文本占的行数,如果要设置2行加...则设置为2*/
            -webkit-box-orient: vertical;
          }
        }
        & > li:hover {
          background-color: #1f1f1f;
          & > div {
            color: #fff;
          }
        }
        & > .playing {
          background-color: #1f1f1f;
          & > div {
            color: #fff;
          }
        }
      }
    }
  }
  .lesson-wrapper {
    background-color: #fff;
    padding: 30px 40px;
    margin-top: 20px;
    height: 100%;
    .an-title {
      height: 44px;
      width: 100%;
      border-bottom: 1px solid #dbdbdb;
      @include displayflex(flex-start, flex-start, row, nowrap);
      @include font-style(
        "PingFangSC-Regular",
        20px,
        rgba(136, 136, 136, 1),
        400
      );
      letter-spacing: 0.57px;
      box-sizing: border-box;
      .title {
        cursor: pointer !important;
        height: 100%;
        box-sizing: border-box;
      }
      .title.active {
        border-bottom: 2px solid rgba(197, 46, 15, 1);
        @include font-style(
          "PingFangSC-Semibold",
          20px,
          rgba(197, 46, 15, 1),
          600
        );
      }
      .division-line {
        margin-left: 20px;
        margin-right: 20px;
      }
    }
    .an-list {
      @include displayflex(flex-start, center, column, nowrap);
      & > .list {
        width: 100%;
        height: 68px;
        @include displayflex(space-between, center, row, nowrap);
        border-bottom: 1px dashed #dbdbdb;
        cursor: pointer !important;
        .video-icon {
          width: 28px;
          height: 28px;
          margin-right: 20px;
          background-image: url("../../assets/old_age_education/lesson-icon2.png");
          background-size: 100% 100%;
        }
        .word {
          flex: 1;
          @include font-style(
            "PingFangSC-Regular",
            18px,
            rgba(58, 58, 58, 1),
            400
          );
          &:hover {
            cursor: pointer !important;
            color: #c52e0f !important;
          }
        }
        .time {
          @include font-style(
            "PingFangSC-Regular",
            16px,
            rgba(122, 122, 122, 1),
            400
          );
        }
        .word.playing {
          color: #c52e0f;
        }
        .time.playing {
          color: #c52e0f;
        }
        .word.played {
          color: #888888;
        }
        .time.played {
          color: #888888;
        }
        .video-icon.played {
          background-image: url("../../assets/old_age_education/lesson-icon2-played.png");
        }
      }
    }
    .lesson-intro {
      @include font-style("PingFangSC-Regular", 18px, rgba(58, 58, 58, 1), 400);
      line-height: 34px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/old_age_education/EducationContent.vue